export default "__VITE_ASSET__e12e4ecc__"